import { takeLatest } from 'redux-saga/effects';
import getInitialShiftsWorker from './getInitialShiftsWorker';
import { GET_INITIAL_SHIFT_PROFILE } from 'profile/redux.actionTypes';

// Watchers
export default function* () {
    yield takeLatest(GET_INITIAL_SHIFT_PROFILE, getInitialShiftsWorker);
}